/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ExchangeLeadRequest
 */
export interface ExchangeLeadRequest {
    /**
     *
     * @type {string}
     * @memberof ExchangeLeadRequest
     */
    target_facility_id: string;
    /**
     * Connectivity is derived from destination exchange_behavior.
     * @type {boolean}
     * @memberof ExchangeLeadRequest
     * @deprecated
     */
    sever_connectivity?: boolean;
}

/**
 * Check if a given object implements the ExchangeLeadRequest interface.
 */
export function instanceOfExchangeLeadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "target_facility_id" in value;

    return isInstance;
}

export function ExchangeLeadRequestFromJSON(json: any): ExchangeLeadRequest {
    return ExchangeLeadRequestFromJSONTyped(json, false);
}

export function ExchangeLeadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeLeadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'target_facility_id': json['target_facility_id'],
        'sever_connectivity': !exists(json, 'sever_connectivity') ? undefined : json['sever_connectivity'],
    };
}

export function ExchangeLeadRequestToJSON(value?: ExchangeLeadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'target_facility_id': value.target_facility_id,
        'sever_connectivity': value.sever_connectivity,
    };
}
